import { render, staticRenderFns } from "./input-messages.vue?vue&type=template&id=76642bf2&"
import script from "./input-messages.vue?vue&type=script&lang=js&"
export * from "./input-messages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports